import React, { memo } from "react";
import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";
import PropTypes from "prop-types";
import {
  getInputNumberFieldMaxLength,
  getInputNumberValue,
  handleNumberDecimalChanges,
  getIntegerPartOfDecimalNumber,
  isCursorPositionAfterDecimal
} from "./formUtils";

const InputNumberField = ({
  name,
  value,
  options,
  numberMode,
  fractionDigits,
  setValue,
  hasError,
}) => {
  const { max: { value: maxValue } = {}, min: { value: minValue } = {} } =
    options || {};
  const maxLength = getInputNumberFieldMaxLength(maxValue);
  const inputKeyDownhandler = (e) => {
    const { key, target } = e;
    if (!isNaN(key)) {
      if (fractionDigits && isCursorPositionAfterDecimal(target)) return;
      const targetValue = fractionDigits
        ? getIntegerPartOfDecimalNumber(target.value)
        : target.value.replaceAll(',', '');
      const comparedValue = targetValue + key;
      if (comparedValue > maxValue || comparedValue < minValue) {
        e.preventDefault();
      }
    }
  };

  return (
    <InputNumber
      id={name}
      inputId={name}
      name={name}
      value={getInputNumberValue(value)}
      min={minValue}
      max={maxValue}
      mode={numberMode}
      minFractionDigits={fractionDigits}
      maxFractionDigits={fractionDigits}
      maxLength={maxLength}
      onChange={(e) => {
        handleNumberDecimalChanges(name, e.value, fractionDigits, setValue);
      }}
      onKeyDown={inputKeyDownhandler}
      className={classNames({
        "p-invalid": hasError,
      })}
      aria-invalid={hasError}
      aria-autocomplete="none"
    />
  );
};

InputNumberField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.shape({
    max: PropTypes.shape({
      value: PropTypes.number,
      message: PropTypes.string,
    }),
    min: PropTypes.shape({
      value: PropTypes.number,
      message: PropTypes.string,
    }),
  }),
  numberMode: PropTypes.string,
  fractionDigits: PropTypes.number,
  errors: PropTypes.object,
  clearErrors: PropTypes.func,
  setValue: PropTypes.func,
};

export default memo(InputNumberField);
